import { IPlanLichSuNapDuLieuCongDangKy_ViewModel } from "../../../model/respone/cong-dang-ky/IPlanLichSuNapDuLieuCongDangKy_ViewModel";
import { generateActionTypeIds } from "../generateActionTypeIds";
import IGenericActionType from "../IGenericActionType";

export const eLichSuNapDuLieuActionsObj = {
    LOAD_START: {} as number,
    LOAD_SUCCESS: [] as IPlanLichSuNapDuLieuCongDangKy_ViewModel[],
    LOAD_ERROR: "",
};

export const eLichSuNapDuLieuActionIds = generateActionTypeIds(eLichSuNapDuLieuActionsObj, "LICH_SU_NAP_DU_LIEU");
export type ILichSuNapDuLieuActionTypes = IGenericActionType<typeof eLichSuNapDuLieuActionsObj, "LICH_SU_NAP_DU_LIEU">;